"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5900],{

/***/ 25900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_AuthLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/AuthLayout/styled.ts
/* eslint-disable indent */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-image: url('",
        "/images/idx-dark.jpg');\n        filter: none;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-image: url('",
        "/images/idx.jpg');\n      filter: blur(5px);\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-size: cover;\n  background-position: right bottom;\n  background-repeat: no-repeat;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  background: ",
        ";\n  opacity: 0.93;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n\n  -webkit-animation-name: loginbackx;\n  animation-name: loginbackx;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 2;\n\n  max-height: 100vh;\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    width: 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var AuthContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-de991532-0"
})(_templateObject());
var BackgroundCoverImage = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-de991532-1"
})(_templateObject3(), function(param) {
    var isDark = param.isDark;
    if (isDark) {
        return (0,styled_components_browser_esm.css)(_templateObject1(), app/* assetPrefix */.Vc);
    }
    return (0,styled_components_browser_esm.css)(_templateObject2(), app/* assetPrefix */.Vc);
});
var BackgroundCoverColor = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-de991532-2"
})(_templateObject4(), ui/* color.light */.$_.light, function(param) {
    var isDark = param.isDark;
    return isDark && "\n    background: none;\n    opacity: 1;\n  ";
});
var Background = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-de991532-3"
})(_templateObject5());


;// CONCATENATED MODULE: ./src/global/AuthLayout/index.tsx


function AuthLayout(param) {
    var children = param.children, _isDark = param.isDark, isDark = _isDark === void 0 ? false : _isDark;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundCoverImage, {
                isDark: isDark
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundCoverColor, {
                isDark: isDark
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, {
                children: children
            })
        ]
    });
}
/* harmony default export */ var global_AuthLayout = (AuthLayout);


/***/ })

}]);